import * as types from "./types";

export default function dialogs(state = {}, action) {
  if (action.type === types.ON_DIALOG_OPEN_CHANGED) {
    return { ...state, [action.id]: action.isOpen };
  }

  return state;
}
